import React, { useState } from "react";
import axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios";
import clsx from "clsx";
import CircularProgress from "@material-ui/core/CircularProgress";
import NotificationsService from "../../laco-common/services/notifications";
import UIModal from "../ui/UIModal";
import UISearchInput from "../ui/UISearchInput";
import { UIStyledTooltip } from "../ui/UIComponents";
import dcaSearchImg from "../../assets/dcasearch.png";

type DCASearchProps = {
	facilityName?: string;
};

export const DCASearch: React.FC<DCASearchProps> = (props: DCASearchProps) => {
	const [searchResultsOpen, setSearchResultsOpen] = useState<boolean>(false);
	const title: string = `Department of Consumer Affairs (DCA) Verified Licensed Prof Dana`;
	const api: AxiosInstance = axios.create({
		baseURL: "https://iservices.dca.ca.gov/api/bcclicenseread/",
		// withCredentials: true,
		// timeout: 2
	});

	const onSearch = (val: string) => {
		console.log("DCASearch.onSearch():", val);
		api.get("getAllBccLicenses", {
			headers: {
				app_id: `9263b815`,
				app_key: `5aab7d54fe698dcf8b9a167e916f7e5c`,
				"Access-Control-Allow-Origin": true,
			},
		})
			.then((response: AxiosResponse) => {
				console.log("response:", response);
			})
			.catch((err) => {
				console.error(err);
			});
	};

	return (
		<UIStyledTooltip title="Search Department of Consumer Affairs Database for Verified Clinician Data">
			<a href="https://search.dca.ca.gov/" target="_blank">
				<img
					src={dcaSearchImg}
					style={{
						backgroundColor: "#095076",
						width: "70px",
						marginLeft: "10px",
						padding: "2px",
						cursor: "pointer",
					}}
					// onClick={() => setSearchResultsOpen(!searchResultsOpen)}
				/>
			</a>
		</UIStyledTooltip>
	);
};
